import { render, staticRenderFns } from "./EligibilityStep.vue?vue&type=template&id=50dd0ba6&lang=pug"
import script from "./EligibilityStep.vue?vue&type=script&lang=js"
export * from "./EligibilityStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default,GroupFind: require('/home/docker/code/frontend/components/GroupFind.vue').default})
